module.exports = __webpack_public_path__ + "static/media/totes_select.ccde9ed0.svg";